import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';

interface CalculationResult {
  totalSalaryAfterTax: number;
  totalSalaryWithHousingFund: number;
  totalSalaryWithoutHousingFund: number;
  annualBaseSalary: number;
  yearEndBonus: number;
  totalSubsidy: number;
  taxBaseSalary: number;
  taxBonus: number;
  insuranceDeduction: number;
  housingFundDeduction: number;
  companyHousingFundContribution: number;
}

interface ResultDisplayProps {
  result: CalculationResult | null;
}

const ResultDisplay: React.FC<ResultDisplayProps> = ({ result }) => {
  if (!result) return null;

  const totalSalaryBeforeTax = result.annualBaseSalary + result.yearEndBonus + result.totalSubsidy;
  const avgMonthlySavings = result.totalSalaryWithHousingFund / 12;

  return (
    <TableContainer component={Paper}>
      <Typography variant="h6" component="div" gutterBottom>
        Salary Calculation Result
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell colSpan={2}>Income</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Annual Base Salary:</TableCell>
            <TableCell>{result.annualBaseSalary.toFixed(2)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Year-End Bonus:</TableCell>
            <TableCell>{result.yearEndBonus.toFixed(2)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Total Subsidy:</TableCell>
            <TableCell>{result.totalSubsidy.toFixed(2)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Total Salary Before Tax:</TableCell>
            <TableCell>{totalSalaryBeforeTax.toFixed(2)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={2}>Insurance</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Insurance Deduction:</TableCell>
            <TableCell>{result.insuranceDeduction.toFixed(2)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={2}>Housing Fund</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Housing Fund Deduction:</TableCell>
            <TableCell>{result.housingFundDeduction.toFixed(2)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Company Housing Fund Contribution:</TableCell>
            <TableCell>{result.companyHousingFundContribution.toFixed(2)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={2}>Tax</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Tax on Base Salary:</TableCell>
            <TableCell>{result.taxBaseSalary.toFixed(2)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Tax on Bonus:</TableCell>
            <TableCell>{result.taxBonus.toFixed(2)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={2}>Final Salary</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Total Salary After Tax:</TableCell>
            <TableCell>{result.totalSalaryAfterTax.toFixed(2)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Total Salary With Housing Fund:</TableCell>
            <TableCell>{result.totalSalaryWithHousingFund.toFixed(2)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Average Monthly Savings:</TableCell>
            <TableCell>{avgMonthlySavings.toFixed(2)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ResultDisplay;